export default "__VITE_ASSET__8b1c0065__"